import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

export const useAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', location.pathname);
  }, [location.pathname]);
};
